const questions = [
    {
        question1: 'is the capital of ',
        id: 'question'
    },
    {
        question2: 'Which country does this flag belong to ?',
        id: 'question'
    }
]

export default questions